module.exports = __webpack_public_path__ + "img/img-abbbb397.da183c65.png";